import { forwardRef, HTMLAttributes } from 'react'
import { Slot } from '@radix-ui/react-slot'
import { omit } from 'lodash'

import { useTheme } from '@/contexts/theme'

import { cn } from '@/lib/utils'

export type SectionProps = HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean
}

const Section = forwardRef<HTMLDivElement, SectionProps>(
  ({ asChild, className, ...props }, ref) => {
    const { theme } = useTheme()
    const Component = asChild ? Slot : 'section'

    return (
      <Component
        ref={ref}
        className={cn(
          { dark: theme?.layout === 'dark' },
          'relative',
          'text-text-primary-light dark:text-text-primary-dark',
          // 'text-[red] dark:text-[blue]',
          'bg-white-light/0 dark:bg-text-accent-light/0',
          className
        )}
        {...omit(props, ['acfe_flexible_layout_title', 'acfe_flexible_layout_toggle'])}
      />
    )
  }
)

export default Section
